import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const AuctionIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M11.704 4.458a.533.533 0 0 0 0-.754L8.296.296a.533.533 0 0 0-.754 0L1.63 6.21a.533.533 0 0 0 0 .754l3.407 3.407a.533.533 0 0 0 .754 0l2.014-2.013 4.585 4.586a1.333 1.333 0 0 0 1.886-1.886L9.69 6.471l2.014-2.013ZM.193 15.614A.267.267 0 0 0 .431 16H7.57a.267.267 0 0 0 .238-.386L6.74 13.481a.267.267 0 0 0-.238-.148H1.498a.267.267 0 0 0-.238.148L.193 15.614Z", fill: "currentColor" })));
});
AuctionIcon.displayName = 'AuctionIcon';
export default AuctionIcon;
